<crm-timer-badge [timer]="timer()"></crm-timer-badge>
